<template>
  <div>
    <Card style="padding-bottom: 40px">
      <Row>
        <Col :span="6">
          <Form :label-width="100">
            <FormItem label="日期:">
              <DatePicker type="month" v-model="dutyForm.DutyCalendarDate" clearable placeholder="选择日期"
                          @on-change="getDutyCalendarData"
                          @on-clear="getDutyCalendarData('clear')" transfer></DatePicker>
            </FormItem>
          </Form>
        </Col>
        <Col :span="6">
          <Form :label-width="100">
            <FormItem label="区县:">
              <Select transfer v-model="dutyForm.county" @on-change="getDutyCalendarData" clearable
                      @on-clear.once="getDutyCalendarData">
                <Option v-for="(item,index) in countyList" :key="index" :value="item.indexCode"
                        :label="item.name"></Option>
              </Select>
            </FormItem>
          </Form>
        </Col>
        <Col span="2" offset="10">
          <Button code="duty.calender.add" type="primary" @click="createModalIsShow" style="margin-bottom: 20px">
            新建值班
          </Button>
        </Col>
      </Row>
      <Table
        :loading="DutyCalendarLoading"
        :columns="DutyCalendarColumns"
        :data="DutyCalendarData"
        :stripe="true"
        border
        :span-method="handleSpan"
        :highlight-current-row="true"
      >
        <template slot-scope="{ row }" slot="action">
          <Button style="color: #0772fd" code="duty.calender.edit" ghost type="text" @click="editDutyModalIsShow(row)">
            编辑
          </Button>
          <el-button size="mini"
                     v-if="row.signFlag === '0'&& $moment().isSame($moment(row.dutyDate),'day' )&&$moment().isBetween($moment(row.dutyDate).format('yyyy-MM-DD') + ' 7:30', $moment(row.dutyDate).format('yyyy-MM-DD') + ' 8:30')"
                     type="text" @click="gotoSign(row)">
            签到
          </el-button>
          <el-button size="mini"
                     v-if="row.signOutFlag === '0'&& $moment().isSame($moment(row.dutyDate),'day' )&&$moment().isBetween($moment(row.dutyDate).format('yyyy-MM-DD') + ' 17:30', $moment(row.dutyDate).format('yyyy-MM-DD') + ' 18:30')"
                     type="text" @click="gotoSignOut(row)">
            签退
          </el-button>
        </template>
      </Table>
    </Card>
    <Modal v-model="newModal"
           :mask-closable="false"
           :title="selDuty.dutyDate ? '编辑值班' : '新建值班'"
           @on-visible-change="newDutyClose">
      <NewDuty ref="NewDuty" :currentDuty="selDuty"></NewDuty>
      <template slot="footer">
        <Button v-if="!selDuty.dutyDate" type="primary"
                @click="submitNewDuty"
                :loading="submitNewDutyBtnLoading">提交
        </Button>
        <Button v-else type="primary" @click="submitEditDuty"
                :loading="submitEditDutyBtnLoading">修改
        </Button>
        <Button @click="newModal=false">取消</Button>
      </template>
    </Modal>

    <Modal
      v-model="signModal"
      :title="signType==='0'?'签到' : '签退'"
      width="800"
    >
      <el-descriptions size="medium" title="值班信息" :column="3" border>
        <el-descriptions-item label="值班开始时间">
          {{ $moment(signInfo.startTime).format('YYYY-MM-DD HH:mm') }}
        </el-descriptions-item>
        <el-descriptions-item label="值班结束时间">
          {{ $moment(signInfo.endTime).format('YYYY-MM-DD HH:mm') }}
        </el-descriptions-item>
        <el-descriptions-item label="值班类型">
          {{ signInfo.dutyTypeName }}
        </el-descriptions-item>
        <el-descriptions-item label="值班人员">
          {{ signInfo.dutyPersonnel }}
        </el-descriptions-item>
        <el-descriptions-item label="值班领导" :span="2">
          {{ signInfo.shiftLeader }}
        </el-descriptions-item>
        <el-descriptions-item label="值班情况" :span="3">
          {{ signInfo.dutySituation }}
        </el-descriptions-item>
        <el-descriptions-item label="值班办结情况" :span="3">
          {{ signInfo.completionSituation }}
        </el-descriptions-item>
        <el-descriptions-item label="值班待办情况" :span="3">
          {{ signInfo.dealtSituation }}
        </el-descriptions-item>
      </el-descriptions>

      <div slot="footer" style="text-align: center;">
        <Button v-if="signType==='0'" type="primary" @click="dutySignRecordss">签到</Button>
        <Button v-if="signType==='1'" type="primary" @click="dutySignRecordss">签退</Button>
      </div>
    </Modal>
  </div>
</template>
<script>
import {dutyColumns} from './js/dutyColumns.js'
import moment from "moment";
import NewDuty from "@/views/Duty/DutyCalendar/NewDuty/NewDuty";

export default {
  components: {
    NewDuty
  },
  data() {
    return {
      signModal: false,
      signType: '',
      signInfo: {},
      dutyCalendarId: '',
      countyList: [],
      selDutyDate: null,
      submitNewDutyBtnLoading: false,
      submitEditDutyBtnLoading: false,
      newModal: false,
      submitEditDutyLoading: false,
      editDutyIsShow: false,
      DutyCalendarLoading: true,
      DutyCalendarColumns: dutyColumns,
      DutyCalendarData: [],
      selDuty: {},
      dutyForm: {
        DutyCalendarDate: new Date(),
        county: null
      }
    }
  },
  mounted() {
    this.getDutyCalendarData()
    this.getCountyList()
    // console.log(this.$moment().diff(this.$moment('2023-08-08T00:00:00+08:00').format('YYYY-MM-DD'), 'day'))
    console.log(this.$moment('2023-08-15T00:00:00+08:00').format('YYYY-MM-DD HH:mm'), this.$moment().isSame(this.$moment('2023-08-15T00:00:00+08:00'), 'day'))
  },
  methods: {
    gotoSign(row) {
      this.signModal = true
      this.signType = '0'
      this.getDutyRecordsByDutyDateAndCounty(row)
    },
    gotoSignOut(row) {
      this.signModal = true
      this.signType = '1'
      this.getDutyRecordsByDutyDateAndCounty(row)
    },
    //获取签到记录
    getDutyRecordsByDutyDateAndCounty(row) {
      this.dutyCalendarId = row.id
      let params = {
        dutyDate: row.dutyDate,
        countyId: row.county
      }
      this.$http.post(`/api/getDutyRecordsByDutyDateAndCounty`, params).then(res => {
        // console.log(res)
        if (res.status === 200) {
          this.signInfo = res.data
        }
      })
    },
    //签到
    dutySignRecordss() {
      if (this.signType === '0') {
        if (!this.$moment().isBetween(this.$moment().format('yyyy-MM-DD') + ' 7:30', this.$moment().format('yyyy-MM-DD') + ' 8:30')) {
          this.$Message.error('未到签到时间')
          return
        }
      } else if (this.signType === '1') {
        if (!this.$moment().isBetween(this.$moment().format('yyyy-MM-DD') + ' 17:30', this.$moment().format('yyyy-MM-DD') + ' 18:30')) {
          this.$Message.error('未到签退时间')
          return
        }
      }
      let params = {
        dutyCalendarId: this.dutyCalendarId,
        signType: this.signType
      }
      this.$http.post('/api/dutySignRecordss', params).then(res => {
        console.log(res)
        if (res.status === 201) {
          this.$Message.success(this.signType === '0' ? '签到成功' : '签退成功')
          this.signModal = false
          this.getDutyCalendarData()
        }
      })
    },
    // 获取区县
    getCountyList() {
      this.$http.get('/api/getCityAndCountys').then(res => {
        console.log(res)
        this.countyList = res.data
      })
    },
    handleSpan({row, column, rowIndex, columnIndex}) {
      //合并第二列,这里columnIndex===1 根据具体业务来，比如本示例中需要合并的name为第二列
      if (columnIndex === 0) {
        //计算合并的行数列数
        let x = row.mergeCol === 0 ? 0 : row.mergeCol;
        let y = row.mergeCol === 0 ? 0 : 1;
        return [x, y];
      }
    },
    formatData(data) {
      let names = [];
      //筛选出不重复的 name值,将其放到 names数组中
      data.forEach((e) => {
        if (!names.includes(e.dutyDate)) {
          names.push(e.dutyDate);
        }
      });

      let nameNums = [];
      //将names数组中的 name值设置默认合并0个单元格,放到 nameNums中
      names.forEach((e) => {
        nameNums.push({dutyDate: e, num: 0});
      });

      //计算每种 name值所在行需要合并的单元格数
      data.forEach((e) => {
        nameNums.forEach((n) => {
          if (e.dutyDate === n.dutyDate) {
            n.num++;
          }
        });
      });

      //将计算后的合并单元格数整合到 data中
      data.forEach((e) => {
        nameNums.forEach((n) => {
          if (e.dutyDate === n.dutyDate) {
            if (names.includes(e.dutyDate)) {
              e.mergeCol = n.num;
              //删除已经设置过的值(防止被合并的单元格进到这个 if 语句中)
              names.splice(names.indexOf(n.dutyDate), 1);
            } else {
              //被合并的单元格设置为 0
              e.mergeCol = 0;
            }
          }
        });
      });
      //将整理后的数据交给表格渲染
      return data;
    },
    submitEditDuty() {
      this.$refs.NewDuty.$refs.DutyRefs.validate((valid) => {
        if (valid) {
          this.submitEditDutyLoading = true
          let requestData = {
            id: this.$refs.NewDuty.dutyForm.id,
            dutyDate: this.$refs.NewDuty.dutyForm.dutyDate,
            post: this.$refs.NewDuty.dutyForm.post,
            dutyPersonnel: this.$refs.NewDuty.dutyForm.dutyPersonnel,
            dutyIphone: this.$refs.NewDuty.dutyForm.dutyIphone,
          }
          this.$http.put('/api/dutyCalendars', requestData).then(res => {
            if (res.status === 200) {
              this.submitEditDutyLoading = false
              this.getDutyCalendarData()
              this.newModal = false
            }
          })
          this.$Message.success('修改成功')
        }
      })
    },
    submitNewDuty() {
      this.$refs.NewDuty.$refs.DutyRefs.validate((valid) => {
        if (valid) {
          this.submitNewDutyBtnLoading = true
          let requestData = {
            dutyDate: this.$refs.NewDuty.dutyForm.dutyDate,
            post: this.$refs.NewDuty.dutyForm.post,
            dutyPersonnel: this.$refs.NewDuty.dutyForm.dutyPersonnel,
            dutyIphone: this.$refs.NewDuty.dutyForm.dutyIphone,
          }
          this.$http.post(`/api/dutyCalendars`, requestData).then(res => {
            if (res.status === 200) {
              this.$Message.success(`提交成功`)
              this.$refs.NewDuty.$refs.DutyRefs.resetFields();
              this.getDutyCalendarData()
              this.submitNewDutyBtnLoading = false
              this.newModal = false
            } else {
              this.$Message.error(`提交失败`)
              this.submitNewDutyBtnLoading = false
              this.newModal = false
            }
          }).catch(() => {
            this.$Message.error(`提交失败`)
            this.submitNewDutyBtnLoading = false
            this.newModal = false
          })
        }
      })
    },
    getDutyCalendarData() {
      this.DutyCalendarLoading = true
      let reqData = {
        yearAndMonth: this.dutyForm.DutyCalendarDate === '' ? null : this.$moment(this.dutyForm.DutyCalendarDate).format('YYYY-MM'),
        countyId: this.dutyForm.county
      }
      this.$http.post('/api/getDutyCalendarList', reqData).then(res => {
        if (res.status === 200) {
          this.DutyCalendarData = this.formatData(res.data)
          this.DutyCalendarLoading = false
        }
      })
    },
    editDutyModalIsShow(row) {
      this.newModal = true
      this.selDuty = row
    },
    // 新建值班窗口
    createModalIsShow() {
      this.newModal = true
    },
    newDutyClose(value) {
      if (!value) {
        this.$refs.NewDuty.$refs.DutyRefs.resetFields();
        this.selDuty = {}
      }
    }
  }
}
</script>
<style scoped>
:deep(.ivu-modal-footer) {
  text-align: left;
}
</style>
